/** Avatar palette class names (DESIGN 2.1). Index = stored `avatarColor` (0..7). */
export const AVATAR_BG = [
  'bg-av-1',
  'bg-av-2',
  'bg-av-3',
  'bg-av-4',
  'bg-av-5',
  'bg-av-6',
  'bg-av-7',
  'bg-av-8',
] as const;

export const AVATAR_COLOR_NAMES = {
  en: ['Peach', 'Saffron', 'Sage', 'Lagoon', 'Sky', 'Lilac', 'Rose', 'Sand'],
  es: ['Melocotón', 'Azafrán', 'Salvia', 'Laguna', 'Cielo', 'Lila', 'Rosa', 'Arena'],
} as const;

function hash(s: string): number {
  let h = 0;
  for (let i = 0; i < s.length; i++) h = (Math.imul(31, h) + s.charCodeAt(i)) | 0;
  return Math.abs(h);
}

/** Chosen colour, else `hash(id) % 8`. */
export function avatarColorIndex(id: string, color: number | null | undefined): number {
  if (color !== null && color !== undefined && color >= 0 && color < 8) return color;
  return hash(id) % 8;
}

export function initialOf(name: string): string {
  const seg = new Intl.Segmenter(undefined, { granularity: 'grapheme' }).segment(name.trim());
  const first = seg[Symbol.iterator]().next().value?.segment;
  return first ? first.toLocaleUpperCase() : '?';
}
